import { render, staticRenderFns } from "./datepicker_badge.vue?vue&type=template&id=c404ed42&"
import script from "./datepicker_badge.vue?vue&type=script&lang=js&"
export * from "./datepicker_badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports